export default __webpack_public_path__ + "static/media/six.9c2c1120.jpeg";